import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { addDays, differenceInCalendarDays, endOfDay, endOfMonth, format, startOfDay, startOfMonth, subDays } from "date-fns";
import { Box, Button, Text } from "grommet";
import _, { orderBy } from "lodash";
import * as React from "react";
import ScrollContainer from "../components/ScrollContainer";
import { CalendarViewEvent } from "./CalendarView";
import "./calendarAgenda.css";

const DailyAgendaView = ({ events, selectedDay, month, onNextDay, onPrevDay }: { events: CalendarViewEvent[]; selectedDay: Date; month: Date; onNextDay: Function; onPrevDay: Function }) => {
    const [currentMonth, setCurrentMonth] = React.useState(month);
    const [eventsPerDay, setEventsPerDay] = React.useState([] as CalendarViewEvent[]);
    const [day, setDay] = React.useState(selectedDay);

    React.useEffect(() => {
        setCurrentMonth(month);
    }, [month]);

    React.useEffect(() => {
        setDay(new Date(selectedDay));
        newEventsArray();
    }, [selectedDay]);

    const previousDay = () => {
        setDay(subDays(day, 1));
        onPrevDay && onPrevDay();
    };

    const nextDay = () => {
        setDay(addDays(day, 1));
        onNextDay && onNextDay();
    };

    const newEventsArray = () => {
        let tempEvents = events.filter((event) => event.start <= endOfDay(day) && event.end >= startOfDay(day)) as CalendarViewEvent[];

        tempEvents.forEach((event) => {
            event.dayOfEvent = differenceInCalendarDays(selectedDay, event.start) + 1;
        });

        setEventsPerDay(orderBy(tempEvents, ["allDay", "start"]));
    };

    return (
        <Box width={"large"} gap="small">
            <Box direction="row" justify="between" align="center">
                <Text size="large" weight={"bold"}>
                    {format(day, "eee, MMM dd")}
                </Text>

                <Box direction="row">
                    <Button icon={<FontAwesomeIcon icon={["fad", "chevron-left"]}></FontAwesomeIcon>} onClick={() => previousDay()}></Button>
                    <Button icon={<FontAwesomeIcon icon={["fad", "chevron-right"]}></FontAwesomeIcon>} onClick={() => nextDay()}></Button>
                </Box>
            </Box>

            <ScrollContainer direction={"-y"}>
                <Box gap="xsmall">
                    {orderBy(eventsPerDay, "start").map((event, key) => (
                        <Box key={event.id + key} gap="small">
                            <Box width="medium" gap="xxsmall" border={[{ size: "medium", color: event.color, side: "left" }]} pad="small" round="xsmall">
                                <Text size="small" weight="bold">
                                    {event.title}
                                </Text>
                                <Text size="small" color="background-contrast" dangerouslySetInnerHTML={{ __html: event.body || "" }}></Text>

                                <Box direction="row" gap="xsmall" align="center">
                                    {event.days > 0 && (
                                        <Box pad="xsmall" round="xsmall" border={{ color: "background-front", size: "small" }} color="background-contrast">
                                            <Text size="small">{`Day ${event.dayOfEvent} of ${event.days + 1}`}</Text>
                                        </Box>
                                    )}
                                    <Text size="small" color="background-contrast">
                                        {event.allDay ? `All-Day` : `${format(event.start, "hh:mm a")} - ${format(event.end, "hh:mm a")}`}
                                    </Text>
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </ScrollContainer>
        </Box>
    );
};

export default DailyAgendaView;
